import styles from "./WizardSteps.module.scss";
import classNames from "classnames";
import {ReactComponent as Success} from "../../images/monochrome-icons/ic-success-circle-thin.svg";
import typography from "../typography.module.scss";
import _ from "lodash";
import React from "react";

const Step = ({ index, label, isActive, onTabSelected, done }) => {
    return (
        <button type="button" onClick={() => onTabSelected(index)} className={classNames(styles["step"], {[styles['active']]: isActive})} disabled={!done}>
            {done ? <Success className={classNames(styles["done-icon"])}/> : <div className={classNames(styles["index"])}>{index}</div>}
            <div className={classNames(typography.body15, styles["label"])}>{label}</div>
        </button>
    );
};

const WizardSteps = ({steps, currentStepIndex, setStep, className}) => {
    return <div className={classNames(styles.base,className)}>
        {_.map(steps, ({label, key}, index) => {
            const isDone = index < currentStepIndex;
            return <Step
                key={key}
                done={isDone}
                onTabSelected={() => setStep(key)}
                isActive={index === currentStepIndex}
                label={label}
                index={index + 1}
            />
        })}
    </div>
}

export default WizardSteps;
